import HomeLayout from 'Layouts/home'
import BlankLayout from 'Layouts/blank'
import { lazy } from 'react'
import DashBoard from '../Modules/dashboard'
import { RoutesName } from './paths'

const WeeklyScreen = lazy(() => import('Modules/weekly'))
const LearningDataScreen = lazy(() => import('Modules/learning-data'))
const ForbiddenScreen = lazy(() => import('Modules/other/403'))

export { RoutesName } from './paths'

export const ROUTES = [
  {
    path: RoutesName.DASHBOARD,
    isAuth: true,
    component: DashBoard,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.DASHBOARDBYID,
    isAuth: true,
    component: DashBoard,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.WEEKLY,
    component: WeeklyScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.WEEKLY_ID,
    component: WeeklyScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.LEARNING_DATA,
    component: LearningDataScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: '/404',
    component: ForbiddenScreen,
    isAuth: false,
    layout: BlankLayout,
    rules: []
  }
]

export default RoutesName
